var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 228","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeWidth":"3"},[React.createElement("path",{"data-name":"Line 41","d":"m2.1 22.1 20-20","key":0}),React.createElement("path",{"data-name":"Line 42","d":"m22.1 22.1-20-20","key":1})]));
}

Close.defaultProps = {"viewBox":"0 0 24.2 24.2"};

module.exports = Close;

Close.default = Close;
